module.exports = __webpack_public_path__ + "img/混动.114a53d5.jpeg";